const Trx = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 32 32' fill='none'>
			<path
				d='M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z'
				fill='#EF0027'
			/>
			<path
				d='M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z'
				stroke='white'
				strokeOpacity='0.2'
			/>
			<path
				d='M21.932 9.91308L7.5 7.25708L15.095 26.3691L25.678 13.4751L21.932 9.91308ZM21.7 11.0831L23.908 13.1821L17.87 14.2751L21.7 11.0831ZM16.558 14.0561L10.194 8.77808L20.596 10.6921L16.558 14.0561ZM16.105 14.9901L15.067 23.5701L9.472 9.48708L16.105 14.9891V14.9901ZM17.065 15.4451L23.752 14.2351L16.082 23.5781L17.065 15.4451Z'
				fill='white'
			/>
		</svg>
	);
};

export default Trx;
